var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { ACTION_FLAG_DEFAULT_VALUE, ACTION_FLAG_NAMES, } from "../constants/productCreation.constants";
import { useRequestState } from "./useRequestState";
var LIST_KEY = "getProductActionFlags";
var createFlagKey = function (name) { return "postProductActionFlag-".concat(name); };
export var useProductActionFlags = function () {
    var dispatch = useDispatch();
    var data = useRequestState(LIST_KEY).data;
    var fetch = function (params) {
        dispatch(customRequestApis({
            requestKey: LIST_KEY,
            method: "GET",
            path: "/asg/Api/V1/PageActionFlags",
            queryParams: __assign({}, params),
        }));
    };
    var createDefaultFlags = function (projectId) {
        ACTION_FLAG_NAMES.forEach(function (name) {
            dispatch(customRequestApis({
                requestKey: createFlagKey(name),
                method: "POST",
                path: "/asg/Api/V1/PageActionFlags",
                body: { data: { name: name, value: ACTION_FLAG_DEFAULT_VALUE, projectId: projectId } },
            }));
        });
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(LIST_KEY));
            ACTION_FLAG_NAMES.forEach(function (name) {
                return dispatch(clearCustomRequest(createFlagKey(name)));
            });
        };
    }, []);
    return { fetch: fetch, createDefaultFlags: createDefaultFlags, flags: data };
};
